import { getSrc, getSrcset } from 'src/utils/utils'
import { date as dateUtils } from 'quasar'

const getDatesBetween = (startDate, endDate) => {
  let dates = []
  let currentDate = new Date(startDate)
  while (currentDate <= endDate) { // eslint-disable-line no-unmodified-loop-condition
    dates.push(new Date(currentDate))
    currentDate.setDate(currentDate.getDate() + 1)
  }
  return dates

  // const s = new Date(startDate)
  // const days = []

  // while (s <= endDate) { // eslint-disable-line no-unmodified-loop-condition
  //   const date = new Date(s) // copy of the date
  //   days.push(date)
  //   s.setDate(s.getDate() + 1)
  // }
  // return days
}

const getters = {
  token: state => state.auth.token,
  tempToken: state => state.auth.tempToken,
  currentToken: state => {
    if (state.auth.token) return state.auth.token
    else if (state.auth.accessToken) return state.auth.accessToken
    return null
  },
  remember: state => state.auth.remember,
  userProfile: state => state.auth.data,
  userFullname: (state, getters) => {
    return getters['auth/userFullname']
  },
  language: state => state.app.language,
  footer: state => state.app.footer,
  prevRouteName: state => state.app.prevRouteName,
  proximity: state => {
    return state.app.geolocation
      ? Object.values(state.app.geolocation).join()
      : null
  },
  reservationForm: state => state.reservationForm.form,
  reservationUserForm: state => state.reservationForm.userForm,
  oneTimeDealCode: state => state.app.oneTimeDealCode,
  extraFlow: state => {
    const extraFlow = state.app.extraFlow
    return extraFlow || null
  },
  minGroupSize: (state, getters) => {
    const { minGroupSize } = getters.extraFlow || {}
    return minGroupSize
  },
  maxGroupSize: (state, getters) => {
    const { maxGroupSize } = getters.extraFlow || {}
    return maxGroupSize
  },
  calendarStartDate: (state, getters) => {
    const { startDate } = getters.extraFlow || {}
    return startDate
  },
  calendarEndDate: (state, getters) => {
    const { endDate } = getters.extraFlow || {}
    return endDate
  },
  excludedDaysOfWeek: (state, getters) => {
    const { excludedDaysOfWeek = [] } = getters.extraFlow || {}
    return excludedDaysOfWeek || null
  },
  excludedDates: (state, getters) => {
    const targetLocation = getters.reservationForm?.location
    return getters.getExcludedDatesByLocation(targetLocation)
  },
  getExcludedDatesByLocation: (state, getters) => (targetLocation) => {
    const {
      excludedDates: excludedDatesNested = [],
      locations: extraFlowLocationsConfig = []
    } = getters.extraFlow || {}

    const locationConfig = extraFlowLocationsConfig.find(loc => loc.id === targetLocation)
    const locationExcludedDates = locationConfig?.excludedDates || []

    let flatDates = excludedDatesNested.reduce((accumulator, item) => {
      if (Array.isArray(item)) {
        getDatesBetween(new Date(item[0]), new Date(item[1])).forEach(date => {
          accumulator.push(dateUtils.formatDate(date, 'YYYY-MM-DD'))
        })
      } else {
        accumulator.push(item)
      }
      return accumulator
    }, [])

    flatDates = flatDates.concat(locationExcludedDates)

    // Add extra dates for specific locations
    if (targetLocation === '31c1d494-f503-4012-9e28-d489b34b8c64') {
      flatDates = [...flatDates, '2024-05-27']
    }
    return flatDates || null
  },
  allRestaurants: (state) => {
    let output = state.directories.restaurants
    const extraFlow = state.app.extraFlow

    if (extraFlow && extraFlow.locations) {
      output = output.filter(item => extraFlow.locations.find(loc => loc.id === item.id))
    }

    return output
  },
  restaurantInfo: (state) => (id) => {
    let output = state.directories.restaurants.find(item => item.id === id)
    if (!output) return
    let imageData = output.extra.image

    output = {
      ...output,
      src: getSrc(imageData),
      srcset: getSrcset(imageData)
    }
    return output
  },
  reservationInfo: (state, getters) => (conf) => {
    const reservations = state.auth.reservations
    if (reservations === undefined) {
      return undefined
    }
    let reservationData = (reservations || []).find(item => item.id === conf)
    return reservationData || null
  },
  reservations: state => state.auth.reservations
}
export default getters
